import 'gumshoejs/dist/gumshoe.polyfills';
import Gumshoe = require('gumshoejs/dist/gumshoe');
import $ from 'gridstrap/lib/gs-zepto';


export class GSTabBar {
	private root;
	private body;
	private gumshoe;

	get isStuck() { return this.root.hasClass('is-stuck'); }
	set isStuck(value) { this.root.toggleClass('is-stuck', !!value); }

	constructor(root) {
		this.root = $(root);
		this.body = $('body');

		this.gumshoe = new Gumshoe('.gs-TabBar a', {
			navClass: 'is-active',
			offset: this.root.height() + 30,
			reflow: true
		});

		this.body.addClass('has-tabbar');
		this.root.removeClass('is-uninitalized');
	}

	checkIfStuck() {
		return this.root.get(0).getBoundingClientRect().top
			- parseInt(this.root.css('top')) <= 1;
	}

	gsOnDestroy() {
		this.body.removeClass('has-tabbar');
		this.gumshoe.destroy();
	}

	gsOnPageScroll() {
		const isStuck = this.checkIfStuck();
		this.isStuck = isStuck;
	}

	gsOnWindowResize() {
		this.gumshoe.setup();
	}
}
